import { makeStyles } from '@material-ui/core';

export default makeStyles(theme => ({
  clampedText: {
    display: '-webkit-box',
    '-webkit-line-clamp': 3,
    '-webkit-box-orient': 'vertical',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  readMoreContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: theme.spacing(1),
  },
  readMoreButton: {
    padding: 0,
    textTransform: 'none',
    fontWeight: 'bold',
    color: theme.palette.secondary.main,
    '&:hover': {
      background: 'transparent',
      textDecoration: 'underline',
    },
  },
  mandatoryChip: {
    marginLeft: `${theme.spacing(1)}px !important`,
    color: `${theme.palette.error.dark} !important`,
    borderColor: theme.palette.error.main,
    backgroundColor: `${theme.palette.error.light} !important`,
    verticalAlign: 'middle',
    cursor: 'default',
  },
  completedColor: {
    color: theme.palette.success.main,
  },
  inProgressColor: {
    color: theme.palette.warning.main,
  },
  notStartedColor: {
    color: theme.palette.grey[500],
  },
}));
